import React, { useState, useEffect } from 'react';
import CountdownTimer from './CountdownTimer';
import './App.css';
import logo from "./WhiteHeart.png"
import axios from "axios";
import { useForm, ValidationError } from '@formspree/react';

function App() {
  const [state, handleSubmit] = useForm("manyblbj");
  const [currentWord, setCurrentWord] = useState('');
  const [wordIndex, setWordIndex] = useState(0);
  const [typing, setTyping] = useState(true); // Control whether we are typing or deleting
  const words = ['soulmate', 'life partner', 'romantic companion'];

  useEffect(() => {
    let typingTimeout;

    if (typing) {
      // Simulate typing effect by adding one character at a time
      if (currentWord.length < words[wordIndex].length) {
        typingTimeout = setTimeout(() => {
          setCurrentWord(words[wordIndex].substring(0, currentWord.length + 1));
        }, 100); // Speed of typing
      } else {
        // Pause briefly before deleting
        typingTimeout = setTimeout(() => {
          setTyping(false);
        }, 10000); // Pause before deleting
      }
    } else {
      // Simulate deleting effect by removing one character at a time
      if (currentWord.length > 0) {
        typingTimeout = setTimeout(() => {
          setCurrentWord(currentWord.substring(0, currentWord.length - 1));
        }, 75); // Speed of deleting
      } else {
        // Move to the next word
        setTyping(true);
        setWordIndex((prevIndex) => (prevIndex + 1) % words.length);
      }
    }

    return () => clearTimeout(typingTimeout);
  }, [currentWord, typing, wordIndex, words]);


  return (
    <div className="app-container">
    <div className="floating-logo">
      <img src={logo} alt="Affinity logo" className="logo-icon" />
      <span className="logo-text">affinity</span>
    </div>
      <header className="header-container">
        <h1>
          Meet your <span className="highlight">{currentWord}</span>
          {/*<span className="cursor"></span>*/}.
        </h1>
        <p>The perfect match, curated just for you.</p>
      </header>

      <section className="timer-section">
        <h2>Time to next match:</h2>
        <CountdownTimer targetDate="2024-12-06T00:00:00" />
      </section>

      <section className="info-section">
        <div className="info-container">
          <p>
            Each month, our app uses a Nobel Prize-winning algorithm to analyze your
            responses and match you with someone truly compatible. No endless
            swiping, just meaningful connections.
          </p>
          <p className="footer-note">Sign up now for early access to our pilot in select U.S. and Canadian cities.</p>
          <form onSubmit={handleSubmit}>
            <input type="email" name="email" placeholder="email@yourdomain.com" />
            <ValidationError 
              prefix="Email" 
              field="email"
              errors={state.errors}
            />
            <button type="submit" disabled={state.succeeded}>Get Started</button>
          </form>
        </div>
        {state.succeeded && <span>Thank you for your submission. We'll send you instructions soon!</span>}
      </section>
    </div>
  );
}

export default App;
